import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=31549cca"
import script from "./DefaultContainer.vue?vue&type=script&lang=js"
export * from "./DefaultContainer.vue?vue&type=script&lang=js"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&id=31549cca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports